import request from '@/sheep/request';

const QuickPreviewApi = {
  // 内容回顾-内容列表
  getContentList: (params = {}) => {
    return request({
      url: '/operation/thirdparty/moca/app/quickPreview/content/list',
      method: 'GET',
      params: {
        pageNum: 1,
        pageSize: 1000,
        ...params,
      },
      custom: {
        showLoading: true,
        showError: true,
        auth: false,
      },
    });
  },

  // 内容回顾-评估列表
  getAssessmentList: (params = {}) => {
    return request({
      url: '/operation/thirdparty/moca/app/quickPreview/assessment/list',
      method: 'GET',
      params: {
        pageNum: 1,
        pageSize: 5,
        ...params,
      },
      custom: {
        showLoading: true,
        showError: true,
        auth: false,
      },
    });
  },
};

export default QuickPreviewApi;
